export const SITE_CONFIG = Object.freeze({
  brand: "mavormira",
  supportEmail: "issue@mavormira.today",
  operatingRegion: "Hong Kong",
  address: null,
  returnAddress: null,
  currency: "USD",
  locale: "en-HK",
  timeZone: "Asia/Hong_Kong",
  shippingFee: 9.99,
  paymentMethod: "Hosted card checkout",
  policyUpdated: "23 October 2026",
});

export const ALCOHOL_NOTICE = "Under the law of Hong Kong, intoxicating liquor must not be sold or supplied to a minor in the course of business.";

export const SHIPPING_COUNTRIES = Object.freeze([
  { code: "HK", name: "Hong Kong" },
  { code: "MO", name: "Macao" },
  { code: "CN", name: "Mainland China" },
  { code: "TW", name: "Taiwan" },
  { code: "SG", name: "Singapore" },
  { code: "JP", name: "Japan" },
  { code: "KR", name: "South Korea" },
  { code: "TH", name: "Thailand" },
  { code: "MY", name: "Malaysia" },
  { code: "ID", name: "Indonesia" },
  { code: "PH", name: "Philippines" },
  { code: "VN", name: "Vietnam" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "CA", name: "Canada" },
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "AT", name: "Austria" },
  { code: "BE", name: "Belgium" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "IE", name: "Ireland" },
  { code: "IT", name: "Italy" },
  { code: "NL", name: "Netherlands" },
  { code: "NO", name: "Norway" },
  { code: "PT", name: "Portugal" },
  { code: "ES", name: "Spain" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
]);

export const formatMoney = (amount) =>
  new Intl.NumberFormat(SITE_CONFIG.locale, {
    style: "currency",
    currency: SITE_CONFIG.currency,
    minimumFractionDigits: 2,
  }).format(Number(amount) || 0);
